module.exports = __webpack_public_path__ + "img/c4.3c1e1adc.jpg";